import { ftyp } from './ftyp.js';
/**
 * Parse a SegmentTypeBox from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed SegmentTypeBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function styp(view) {
    return ftyp(view);
}
//# sourceMappingURL=styp.js.map